import React from 'react'
import styles from './FootPrintVsCompensationText.module.scss'
import { CustomTitle } from 'src/components'

interface FootPrintVsCompensationTextProps {
  text1: string,
  text2: string
}

const FootPrintVsCompensationText: React.FC<FootPrintVsCompensationTextProps> = ({ text1, text2 }) => {
  return <>
    <CustomTitle className={styles.text1} label={text1} />
    <CustomTitle level={3} type={null} className={styles.text2} label={text2} />
  </>
}

export default FootPrintVsCompensationText
